function runLoader() {
    const loaderWipe = loader.querySelector(".js-loader-wipe"),
          loaderItems = loader.querySelectorAll(".js-loader-items"),
          siteLogo = document.querySelector(".js-site-logo"),
          navStaggerItems = document.querySelectorAll(".js-nav-item-stagger"),
          stopScrollingClass = 'stop-scrolling',
          isActiveClass = 'is-active';

    body.classList.add(stopScrollingClass);

    //loader tl
    const loaderTl = gsap.timeline({paused:true, onComplete: initHomeFlickitySlider});

    loaderTl.to(loader, 0.6, { backgroundColor: 'transparent' })
            .set(siteLogo, { autoAlpha: 0 })
            .set(navStaggerItems, { autoAlpha: 0, marginTop: "-2rem" })
            .call(iconFlick)
            .set(loaderWipe, { autoAlpha: 0 }, "+=2.2")
            .to(loader, 0.8, { autoAlpha: 0, ease: Power4.easeInOut },"+=0.4")
            .to(siteLogo, 0.3, { autoAlpha: 1, ease: Power4.easeInOut },"-=0.2")
            .to(navStaggerItems, {
                marginTop: 0,
                autoAlpha: 1,
                stagger: 0.04
            },"-=0.3");
            
    loaderTl.pause();
    loaderTl.restart();


    function iconFlick() {
        loaderItems.forEach(loaderItem => {
            const icons = loaderItem.querySelectorAll(".js-loader-item");
            let len = icons.length;
            let idx = 0;
            const showNext = function () {
                const entry = icons[idx];
                if (idx < len) {
                    idx++;
                    entry.classList.add(isActiveClass);
                    if (idx < 10) {
                        setTimeout(function(){
                            entry.classList.remove(isActiveClass);
                        }, 200);
                        setTimeout(showNext, 200);
                    } else if (idx == 10) {
                        setTimeout(function(){
                            entry.classList.remove(isActiveClass);
                        }, 400); 
                    }
                } else {
                    idx = 0;
                }
            }
            showNext();
        });
    }

    function initHomeFlickitySlider() {
        body.classList.remove(stopScrollingClass);

        //get hero flickity data
        var flkty = Flickity.data(heroSlider)
        flkty.unpausePlayer();
    }

}
